import React, { useEffect, useState, useContext } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";
import { getHoras } from "./../getData";
import "../../styles/Calendario.css"; // Archivo CSS personalizado
import { formatFecha } from "../../hooks/useFetchData";
import { FormContext } from "../../context/FormContext"; 


const horariosPorPais = {
  ec: { AM: 9, PM: 10 },
  pe: { AM: 1, PM: 2 },
  co: { AM: 6, PM: 7 },
  cl: { AM: 4, PM: 5 }, // Valores actuales
};

// Registrar la configuración personalizada para que el domingo sea el primer día
registerLocale("es-custom", {
  ...es,
  options: {
    ...es.options,
    weekStartsOn: 0,
  },
});

const CalendarioReagendamiento = ({
  nextStep,
  prevStep,
  datosReserva,
  setDatosReserva
}) => {
  // Datos de la reserva para reagendamiento
  // console.log("datos de la reserva", datosReserva);
  const { data: reservaData, status: reservaStatus } = datosReserva || {};
  const { datos_tienda: dataTiendas} = datosReserva?.data
  const { json_request, status: reservaCurrentStatus } = reservaData || {};
  const { parameters } = json_request || {};

  // Información extraída para el reagendamiento
  // console.log("Datos de la tienda", dataTiendas);
  // console.log("Datos servicio" , datosReserva?.data?.nombre_servicio)
  // console.log("json request", datosReserva.data )
  // console.log("parametros",parameters)

  //   const { formData, updateFormData } = useContext(FormContext);
  const {formData} = useContext(FormContext)

  const [activeTab, setActiveTab] = useState("AM");
  const [selectedTime, setSelectedTime] = useState(null);
  const [availableTimes, setAvailableTimes] = useState([]);
  const [loading, setLoading] = useState(false);

  function getFirstAvailableDate() {
    let date = new Date();
    date.setDate(date.getDate()); // Comenzar desde mañana
    
    // Buscar siguiente día hábil
    while (date.getDay() === 0) {
      date.setDate(date.getDate());
    }
    
    return date;
  }

  const [selectedDate, setSelectedDate] = useState(() =>
    getFirstAvailableDate(new Date())
  );
  

  const formatFechaYHora = (rsa_fecha) => {
    if (!rsa_fecha) return { fecha: null, hora: null };
    const [fecha, hora] = rsa_fecha.split(" "); // Divide el string
    return { fecha, hora };
  };

  useEffect(() => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
  
    // Si es antes de las 14:30, AM. Si no, PM.
    if (hours < 14 || (hours === 14 && minutes < 30)) {
      setActiveTab("AM");
    } else {
      setActiveTab("PM");
    }
  
    // También actualizamos el selectedHorarios basado en el país y el turno actual
    const pais = formData.pais || "cl";
    const turno = (hours < 14 || (hours === 14 && minutes < 30)) ? "AM" : "PM";
    setSelectedHorarios(horariosPorPais[pais]?.[turno] || 4);
  }, []);
  

  const [selectedHorarios, setSelectedHorarios] = useState(() => {
    const pais = formData.pais || "cl";
    return horariosPorPais[pais]?.AM || 4;
  });

  
  // Llamar al endpoint cada vez que cambie la fecha o el turno
  useEffect(() => {
    const fetchAvailableTimes = async () => {
      setLoading(true); // Activar el estado de carga
      try {
        const { cfg_codigo, rsa_fecha, tpc_codigo } = parameters;
        if (!cfg_codigo || !rsa_fecha) {
          // Validación: datos faltantes para la solicitud de horarios
          // console.log(
          //   "Datos faltantes para la solicitud. Verificar TiendaSeleccionada y fechaSeleccionada."
          // );
          setAvailableTimes([]);
          return;
        }

        const selectedTienda = cfg_codigo;
        
        const selectedServicio = tpc_codigo;
        const { fecha, hora } = formatFechaYHora(parameters.rsa_fecha);

        const formatDate = (date: Date): string => {
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Los meses en JavaScript son 0-indexados
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        };

        // Uso de la función
        const formattedDate = formatDate(selectedDate);

        // Fecha seleccionada formateada para reagendamiento
        // console.log("SELECTED DATE REAGENDAMIENTO ", formattedDate);

        // Llamada al servicio para obtener horarios
        const horas = await getHoras(
          selectedTienda,
          selectedServicio,
          selectedHorarios,
          formattedDate
        );

        // Verificar y actualizar horarios disponibles
        if (horas && Array.isArray(horas)) {
          const fechaActual = new Date();
          const diaActual = fechaActual.toLocaleDateString('es-CL', {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          }).replace(/-/g, "/");

          const hora = fechaActual.getHours();
          const minutos = fechaActual.getMinutes();

          const horariosFiltrados = horas.filter((item) => {
            const [horaItem, minutoItem] = item.hora.split(":").map(Number);
            if(diaActual === formattedDate){
              return (horaItem > hora || (hora === horaItem && minutoItem >= minutos));
            }else{
              return true;
            }
          });
          setAvailableTimes(horariosFiltrados.map((item) => item.hora));
        } else {
          setAvailableTimes([]);
          // No se encontraron horarios disponibles para la fecha seleccionada
          // console.log("No se encontraron horarios disponibles.");
        }
      } catch (error) {
        // Error al obtener horarios disponibles para reagendamiento
        console.error("Error al obtener los horarios disponibles:", error);
        setAvailableTimes([]);
      } finally {
        setLoading(false); // Desactivar el estado de carga
      }
    };

    fetchAvailableTimes();
  }, [selectedDate, activeTab]);

  const handleDateChange = (date) => {
    // Nueva fecha seleccionada para reagendamiento
    // console.log("Fecha seleccionada:", date);
    setSelectedDate(date);


  const pais = formData.pais || "cl";
  setSelectedHorarios(horariosPorPais[pais]?.[activeTab] || 4);
  };

  const handleTimeSelect = (time) => {
    // Nueva hora seleccionada para reagendamiento
    // console.log("Hora seleccionada:", time);
    setSelectedTime(time);
  };

  const handleTabChange = (tab) => {
    // Cambio de turno (mañana/tarde) en reagendamiento
    // console.log(`Pestaña ${tab} seleccionada`);
    setActiveTab(tab);
    setSelectedTime(null);

    const pais = formData.pais || "cl";
    setSelectedHorarios(horariosPorPais[pais]?.[tab] || 4);
  };

  const formatFechaHora = (fecha, hora) => {
    const fechaFormateada = new Intl.DateTimeFormat("es-CL", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    })
      .format(fecha)
      .replace(/-/g, "/");

    return `${fechaFormateada} ${hora}`;
  };

  const handleContinue = () => {
    // Confirmación de nueva fecha y hora para reagendamiento
    // console.log("Fecha y hora seleccionadas al continuar:", {
    //   fechaSeleccionada: formatFecha(selectedDate),
    //   horaSeleccionada: selectedTime,
    // });

    setDatosReserva({
      datos_tienda:{...dataTiendas},
      datos_reserva:{ 
        ...parameters,
        rsa_fecha: formatFecha(selectedDate) + " " + selectedTime,
        rsa_codigo: datosReserva.data.id_reserva
      },
      nombre_servicio: datosReserva?.data?.nombre_servicio
    });
    nextStep();
  };

  return (
    <>
      <div
        className={`col-md-6 pads0-768 ${formData?.cadena === "eco" ? "eco-theme" : ""} ${formData?.cadena === "gmo" ? "gmo-theme" : ""}`}
        id="booking-calendar"
      >
        <div className="row booking-calendar-container" id="react-booking">
          <div className="col-12 pads0">
            <div className="row mb20">
              <div className="col-12 text-center">
                <h3>Seleccione una fecha</h3>
              </div>
            </div>
          </div>
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            className="calendar-step3"
            inline
            locale="es-custom"
            minDate={new Date(new Date().setDate(new Date().getDate()))} // Bloquea desde mañana
          />

          <div className="row text-center mb20 mt40">
            <div className="col-12">
              <h4 className="monts-sb mb0">Seleccione una cita disponible</h4>
            </div>
          </div>

          {/* Tabs adaptados al diseño */}
          <div className="row text-center mb20 select-hour justify-content-center">
            <div
              className={`col-md-5 col-6 pads0-768 select-hour-option hour-option-day ${
                activeTab === "AM" ? "hour-selected" : ""
              }`}
              onClick={() => handleTabChange("AM")}
            >
              <p className="dayhour-schedule mb0">MAÑANA</p>
              <p className="hour-schedule mb0-768">09:00 am - 14:00 pm</p>
            </div>
            <div
              className={`col-md-5 col-6 pads0-768 select-hour-option hour-option-afternoon ${
                activeTab === "PM" ? "hour-selected" : ""
              }`}
              onClick={() => handleTabChange("PM")}
            >
              <p className="dayhour-schedule mb0">TARDE</p>
              <p className="hour-schedule mb0-768">14:00 pm - 20:00 pm</p>
            </div>
          </div>

          {/* Horarios disponibles */}
          {loading ? (
            <div className="row text-center">
              <div className="col-12">
                <p>Cargando horarios disponibles...</p>
              </div>
            </div>
          ) : (
            <div className="row select-prof">
              {availableTimes.map((time) => (
                <div
                  key={time}
                  className="col-md-3 col-6 pads5"
                  onClick={() => handleTimeSelect(time)}
                >
                  <div
                    className={`available-hour mb20 ${
                      activeTab === "AM"
                        ? "available-day"
                        : "available-afternoon"
                    } ${selectedTime === time ? "prof-selected" : ""}`}
                  >
                    <h3 className="monts-b mtb0">{time}</h3>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Botón Continuar */}
          {selectedDate && selectedTime && !loading && (
            <div className="row mt20 container-button-contact">
              <div
                className="step-contact-button upper text-end"
                onClick={handleContinue}
              >
                Continuar
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CalendarioReagendamiento;
